// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const DashAssistance    = lazy(() => import('../../views/dashboardsassistances/list'))

const DashboardsAssistance = [
  {
    path: 'dashboardsassistances/list',
    element: <DashAssistance/>
  }
]

export default DashboardsAssistance
